import React, { Component } from "react";

import "./Classes.scss";

import UiBtnBasket from "../../components/buttons/UiBtnBasket";
import UiBtnTop from "../../components/buttons/UiBtnTop";
import UiCatalogFilter from "../../components/catalog/UiCatalogFilter";
import UiCatalogCard from "../../components/cards/UiCatalogCard";
import UiHeader from "../../components/header/UiHeader";
import UiFooter from "../../components/footer/UiFooter";
import UiModalCatalog from "../../components/modals/UiModalCatalog";
import UiModalLogin from "../../components/modals/UiModalLogin";
import UiPageTitle from "../../components/header/UiPageTitle";

import { Helmet } from "react-helmet";

import { storeData, retrieveData, getBasketNum } from "../../services/Storage";

class AgreementPage extends Component {
    state = {
        showTopBtn: false,
        scrollHeader: false,
        basketNum: 0,
        modalCatalogActive: false,
        modalLoginActive: false,
        user: null,

        settings: {},
        selectedItem: {
            title: null,
            description: null,
            composition: null,
            price: null,
            modifications: null,
        },

        cart: [],
        classesList: [],
        giftsList: [],
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this._load();

        window.addEventListener("scroll", (event) => {
            let scroll = document.documentElement.scrollTop;
            this.setState({ topOffset: scroll });
            if (this.state.topOffset > 170) {
                this.setState({ scrollHeader: true });
            } else {
                this.setState({ scrollHeader: false });
            }
            if (this.state.topOffset > 500) {
                this.setState({ showTopBtn: true });
            } else {
                this.setState({ showTopBtn: false });
            }
        });
    }

    _load() {
        let _cart = retrieveData("cart");
        let _user = retrieveData("mfUser");
        if (_cart) {
            this.setState({ cart: _cart });
            this.setState({ basketNum: getBasketNum(_cart) });
        }
        if (_user) {
            this.setState({ user: _user });
        }

    }


    render() {

        return (
            <div ref={this.divPage} id="page">
                <Helmet>
                    <title>СОГЛАСИЕ на получение рассылки и рекламных материалов</title>
                    <meta name="description" content="СОГЛАСИЕ на получение рассылки и рекламных материалов" />
                    <meta name="keywords" content="цветочная подписка москва, доставка цветов москва" />
                </Helmet>
                <div id="wrapper" className="page-wrapper">
                    {/* gifts header */}
                    <section className="section classes-header">
                        <UiHeader
                            callBack={(value) => { }}
                            page="subscribe"
                            scrollHeader={this.state.scrollHeader}
                            basketNum={this.state.basketNum}
                            isLogin={this.state.user}
                            loginClick={() => this.setState({ modalLoginActive: true })}
                            profileClick={() => this.props.history.push("/profile")}
                        />
                    </section>
                    <UiCatalogFilter />
                    {/* page title */}
                    <section className="section classes-title">
                        <UiPageTitle
                            backImg={require("../../assets/images/header/bg-breacrum.jpg")}
                            pageLink="/subscribe"
                            pageName="СОГЛАСИЕ на получение рассылки и рекламных материалов"
                            title=""
                        />
                    </section>
                    {/* gifts catalog */}
                    <section className="section classes-catalog">
                        <div className="wrapper">
                            <div className="classes-catalog-wrap">


                                <h2>СОГЛАСИЕ на получение рассылки и рекламных материалов</h2>
                         
                                <p><strong>&nbsp;</strong></p>
                                <p>Я, регистрируясь и/или вводя свои данные на сайте: <u>https://mateflowers.ru</u>, их сервисах или их поддоменах, в приложении MATE flowers &amp; gifts даю свое согласие на получение рассылки, в том числе рекламной, содержащей информацию, в том числе, но не ограничиваясь, о товарах и услугах, наличии специальных предложений, акций в отношении них, условиях, связанных с приобретением и использованием указанных товаров и услуг, о проведении мероприятий, презентаций, предложениях партнеров, а также рассылок подготовленных в качестве личных рекомендаций для меня с учетом анализа покупательского поведения посредством e-mail- рассылки (направление сообщений на электронную почту), SMS- рассылки (служба коротких сообщений), почтовой рассылки, телефонных звонков, push-уведомлений, мессенджеров, любых иных средств связи, в том числе посредством сети Интернет от Индивидуального предпринимателя Гайдуковой Кристины Дмитриевны, ИНН: 371122369833, ОГРНИП: 319370200033300.</p>
                                <p>Давая такое согласие, я подтверждаю, что действую по своей воле и в своем интересе, а также обязуюсь предоставить достоверные данные.</p>
                                <p>Я подтверждаю, что владею информацией о том, что в любой момент, я вправе отозвать согласие данного соглашения и отписаться от получения рассылок путем перехода по соответствующей ссылке &laquo;отписаться&raquo;, имеющемся в каждом письме, либо путем направления запроса на электронную почту: <a href="mailto:info@mateflowers.ru">info@mateflowers.ru.</a></p>
                                <p>Также, я проинформирован (-на), что при возникновении вопросов относительно отказа, в том числе от SMS-рассылок, я могу обратиться за помощью, отправив письмо на следующий адрес электронной почты: <a href="mailto:info@mateflowers.ru">info@mateflowers.ru.</a></p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <h3>Реквизиты и контактная информация:</h3>
                                <p>Индивидуальный предприниматель Гайдукова Кристина Дмитриевна ИНН: 371122369833</p>
                                <p>ОГРНИП: 319370200033300</p>
                                <p>e-mail: <a href="mailto:info@mateflowers.ru">info@mateflowers.ru</a></p>
                            </div>
                        </div>
                    </section>
                    {/* gifts footer */}
                    <section className="section classes-footer">
                        <UiFooter />
                    </section>
                </div>

                <UiBtnTop showTopBtn={this.state.showTopBtn} />

                <UiBtnBasket
                    cartNum={this.state.basketNum}
                    infoActive={this.state.infoActive}
                    callBack={() => this.setState({ infoActive: false })}
                />

                <UiModalLogin
                    modalOpen={this.state.modalLoginActive}
                    modalClose={() => this.setState({ modalLoginActive: false })}
                    callBack={() => {
                        this.setState({ modalLoginActive: false });
                        this.props.history.push("/profile");
                    }}
                />

            </div>
        );
    }
}

export default AgreementPage;
